module.exports = __webpack_public_path__ + "static/media/AM1.052c6ab7.jpg";